/**
 * Created by wwei on 2018-08-01.
 */

import React, { Component } from 'react';
import request from 'superagent';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Tag } from 'antd';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import ToolBar from '../../commons/ToolBar.js';
import Loading from '../../commons/Loading.js';
import {openNotification, NotificationType, getUrl, permissionCheck} from "../../commons/CommonUtils.js";
import Constant, {Permissions} from "../../commons/Constants.js";
import AppDetail from './AppDetail.js';
import CopyDialog from './CopyDialog.js';

class AppList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            loading: true,
            openSlide: false,
            editMode: false,
            selected: undefined,
            containerHeight: 2000,
            secret: '',
            title: ''
        };
    }

    componentDidMount() {
        this.init();
    }

    init = () => {
        this.refs.table.cleanSelected();
        this.setState({loading: true, dataList: []});
        const url = getUrl(Constant.Service.vault, "/app/all");
        request.get(url).withCredentials().then(res => {
            this.setState({dataList: res.body, loading: false});
        }).then(() => {
            const height = document.getElementById('container').clientHeight - 110;
            this.setState({containerHeight: height});
        }).catch(err => {
            console.error("Failed to get apps. ", err);
            openNotification("Failed to get global applications.", NotificationType.error);
            this.setState({loading: false});
        });
    }

    createCustomToolBar = props => {
        const { openSlide } = this.state;
        const isHideAdd = !permissionCheck([Permissions.AppVault.ADD]);
        return (
            <div>
                <div className='buttonFiled' style={{ display: openSlide ? 'none' : 'block' }}>
                    <ToolBar onFresh={this.init}
                             onAdd={() => {this.setState({openSlide: true, editMode: false})}}
                             isHideAdd={isHideAdd}/>
                </div>
                <div className='searchFiled' style={{width: openSlide ? '100%': ''}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    detailCallback = (refresh, close, obj) => {
        if (refresh) {
            this.init();
        }
        if (close) {
            this.setState({openSlide: false, selected: undefined});
        }
        if (obj !== undefined) {
            if (obj instanceof Object) {
                this.setState({secret: obj.secret, appID: obj.id, title: 'Application ' + obj.name + ' Created'});
            } else {
                this.setState({secret: obj, appID: undefined, title: 'Regenerate Secret'});
            }
            this.copyModal.open();
        }
    }

    nameFormat = (cell, row) => {
        if (cell) {
            return <a onClick={() => this.setState({selected: row, editMode: true, openSlide: true})}><div>{cell}</div></a>
        }
        return '';
    }

    scopeFormat = (cell) => {
        if (cell && Array.isArray(cell) && cell.length > 0) {
            return (
                <div>
                    {cell.sort((obj1, obj2) => {
                        return obj1 === obj2 ? 0 : (obj1 > obj2 ? 1 : -1);
                    }).map((r, index) => {
                        return <Tag key={index} style={{cursor: 'default', display: 'block', float: 'left', marginBottom: 3}}>{r}</Tag>
                    })}
                </div>
            )
        }
        return '';
    }

    timeFormat = cell => {
        if (cell) {
            return moment(cell).local().format("YYYY-MM-DD HH:mm:ss");
        }
        return '';
    }

    trClassFormat = (row, rowIndex) => {
        const s = this.state.selected;
        if (s !== undefined && row.id === s.id) {
            return "table_selected_row";
        }
    };

    render() {
        const {dataList, loading, openSlide, editMode,
            containerHeight, selected, secret, appID, title} = this.state;
        const options = {
            defaultSortName: 'name',
            defaultSortOrder: 'asc',
            noDataText: loading ? <Loading /> : 'No application found.',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500
        };
        const tableOptions = {
            data: dataList, search: true, options: options,
            multiColumnSearch: true,
            maxHeight: containerHeight,
            bodyStyle: {overflowX: 'hidden'}
        };
        return (
            <div className="page-container">
                <div id="container" className={`${openSlide ? 'col-md-5': 'col-md-12'} list`}>
                    <h2 className="page-title">App Vault</h2>
                    <BootstrapTable ref="table" {...tableOptions}
                                    trClassName={this.trClassFormat} striped hover condensed>
                        <TableHeaderColumn dataField='name' dataSort={ true }
                                           width="22%" dataFormat={this.nameFormat}>
                            Name
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='id' dataSort={ true }
                                           width="18%" isKey hidden={openSlide}>
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='scopes' dataSort={ true }
                                           dataFormat={this.scopeFormat} width="45%"
                                           hidden={openSlide}>
                            Scopes
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='updatedOn' dataSort={ true } width="15%"
                                           dataFormat={this.timeFormat} hidden={openSlide}>
                            Last Update
                        </TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div id="detailContainer" className={`${openSlide ? 'col-md-7': 'col-md-0'} detailInfo`}>
                    {openSlide && (
                        <AppDetail cb={this.detailCallback} editMode={editMode} selected={selected}/>
                    )}
                </div>
                <CopyDialog ref={modal => {this.copyModal = modal}} secret={secret} appID={appID} title={title}/>
            </div>
        )
    }

}

export default AppList;


// WEBPACK FOOTER //
// ./src/modules/appstore/AppList.js